import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l10 0","key":"svg-0"}],["path",{"d":"M4 18l10 0","key":"svg-1"}],["path",{"d":"M4 12h17l-3 -3m0 6l3 -3","key":"svg-2"}]]

const IconTextWrapDisabled = createReactComponent('outline', 'text-wrap-disabled', 'TextWrapDisabled', __iconNode);

export default IconTextWrapDisabled;